import React from "react";

const Alert = (props) => {
  
  
  return (
	<div className={`alert alert-${props.type}`} role="alert" dangerouslySetInnerHTML={{__html: props.msg}}></div>
  );
};

export default Alert;
